
//Files to show up 
import BuyvotesButton from './react-frontend/BuyvotesButton.jsx';

import * as BuyvotesConstants from './constants';
import { tr } from 'date-fns/locale';

wp.hooks.addFilter('wpvc_buyvotes_btn','wpvc_buyvotes_button', getBuyvotesButton);

function getBuyvotesButton(content, props, butn_msg){
  const { short, singlepost } = props;
  let button_status = false;
  
  if(typeof props.update_vote_count !== "undefined"){
    button_status = props.update_vote_count.buy_vote ? props.update_vote_count.buy_vote : !butn_msg;
  }else if(butn_msg == 'already'){
    button_status = true;
  }
  else{
    button_status = (typeof singlepost.vote_button_status !== "undefined") && (typeof singlepost.vote_button_status.update_vote_count !== "undefined") ? singlepost.vote_button_status.update_vote_count.buy_vote : false;
  }

  if((typeof short.allcatoption !== "undefined") && short.allcatoption.wpvc_category_buyvotes_settings == "on" && (button_status == true)){
    return (
      <BuyvotesButton {...props} {...BuyvotesConstants}/>
    );
  }
  return content;
}